module.exports = __webpack_public_path__ + "img/难观摩.0ab6f895.png";